import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { TOAST_TYPES } from './ToastTypes';
import 'react-toastify/dist/ReactToastify.css';
import './styles.scss';

export const showToast = (config) => {
  const {
    type = TOAST_TYPES.INFO,
    message,
    autoClose = 5000,
  } = config;

  toast(message, {
    type,
    autoClose,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

function ToastWrapper() {
  return (
    <ToastContainer
      position='top-right'
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
}

export default ToastWrapper;
